import {Component, Vue} from 'vue-property-decorator';

@Component
export default class DialogEventsMixin extends Vue {
    public open($event: any) {
        this.$emit('open', $event);
    }
    
    public opened($event: any) {
        this.$emit('opened', $event);
    }
    
    public close($event: any) {
        this.$emit('close', $event);
    }
    
    public closed($event: any) {
        this.$emit('closed', $event);
    }
}
